import useTranslations from '../../../hooks/useTranslations'
import ANTDTable from '../../../shared/antd/ANTDTable'
import { length } from '../../../utils/javascript'

const AutomobileModifications = () => {
  const { t } = useTranslations()
  const dataSource = [
    {
      key: '1',
      date: '2021-01-15',
      repairCategory: 'Engine',
      errorCode: 'P0300',
      errorDescription: 'inv_RepairInstruction3',
      resolution: 'inv_AutomobileIssueResolution1',
      serviceCenterName: 'ABC Auto Repair',
      engineDppUpdated: 'Yes',
      dppOfPartExtracted: 'N/A',
      dppOfPartInserted: 'N/A',
    },
    {
      key: '2',
      date: '2021-02-10',
      repairCategory: 'Body',
      errorCode: 'N/A',
      errorDescription: 'inv_AutomobileIssueDescription1',
      resolution: 'inv_AutomobileIssueResolution2',
      serviceCenterName: 'XYZ Body Shop',
      engineDppUpdated: 'Yes',
      dppOfPartExtracted: 'N/A',
      dppOfPartInserted: 'N/A',
    },
    {
      key: '3',
      date: '2021-05-10',
      repairCategory: 'Engine',
      errorCode: 'P0420',
      errorDescription: 'inv_AutomobileIssueDescription2',
      resolution: 'inv_AutomobileIssueResolution3',
      serviceCenterName: 'DEF Exhaust Specialists',
      engineDppUpdated: 'Yes',
      dppOfPartExtracted: '5p165e4d-30jk-3456',
      dppOfPartInserted: '6p165e4d-30jk-8901',
    },
    {
      key: '4',
      date: '2021-06-15',
      repairCategory: 'Body',
      errorCode: 'N/A',
      errorDescription: 'inv_AutomobileIssueDescription3',
      resolution: 'inv_AutomobileIssueResolution4',
      serviceCenterName: 'GHI Auto Collision',
      engineDppUpdated: 'Yes',
      dppOfPartExtracted: 'N/A',
      dppOfPartInserted: 'N/A',
    },
    {
      key: '5',
      date: '2021-09-20',
      repairCategory: 'Engine',
      errorCode: 'P0171',
      errorDescription: 'inv_AutomobileIssueDescription4',
      resolution: 'inv_AutomobileIssueResolution5',
      serviceCenterName: 'JKL Engine Diagnostics',
      engineDppUpdated: 'Yes',
      dppOfPartExtracted: 'N/A',
      dppOfPartInserted: 'N/A',
    },
    // {
    //   key: '6',
    //   date: '2022-01-20',
    //   repairCategory: 'Body',
    //   errorCode: 'N/A',
    //   errorDescription: 'inv_PartIssueDescription1',
    //   resolution: 'inv_PartResolution1',
    //   serviceCenterName: 'MNO Bodyworks',
    //   engineDppUpdated: 'Yes',
    //   dppOfPartExtracted: 'N/A',
    //   dppOfPartInserted: 'N/A',
    // },
    // {
    //   key: '7',
    //   date: '2022-03-05',
    //   repairCategory: 'Engine',
    //   errorCode: 'P0128',
    //   errorDescription: 'inv_PartIssueDescription4',
    //   resolution: 'inv_PartResolution4',
    //   serviceCenterName: 'PQR Auto Service',
    //   engineDppUpdated: 'Yes',
    //   dppOfPartExtracted: '4p165e4d-30jk-2345',
    //   dppOfPartInserted: '5p165e4d-30jk-9101',
    // },
    // {
    //   key: '8',
    //   date: '2022-04-10',
    //   repairCategory: 'Body',
    //   errorCode: 'N/A',
    //   errorDescription: 'Front fender replacement',
    //   resolution: 'inv_PartResolution2',
    //   serviceCenterName: 'STU Auto Body',
    //   engineDppUpdated: 'Yes',
    //   dppOfPartExtracted: '6p165e4d-30jk-5678',
    //   dppOfPartInserted: '7p165e4d-30jk-1234',
    // },
    // {
    //   key: '9',
    //   date: '2022-07-15',
    //   repairCategory: 'Engine',
    //   errorCode: 'P0100',
    //   errorDescription: 'Mass or Volume Air Flow Circuit Malfunction',
    //   resolution: 'inv_PartResolution5',
    //   serviceCenterName: 'VWX Automotive Solutions',
    //   engineDppUpdated: 'Yes',
    //   dppOfPartExtracted: '8p165e4d-30jk-9101',
    //   dppOfPartInserted: '9p165e4d-30jk-5678',
    // },
    // {
    //   key: '10',
    //   date: '2022-08-25',
    //   repairCategory: 'Body',
    //   errorCode: 'N/A',
    //   errorDescription: 'inv_PartIssueDescription3',
    //   resolution: 'inv_PartResolution3',
    //   serviceCenterName: 'YZA Glass Repair',
    //   engineDppUpdated: 'Yes',
    //   dppOfPartExtracted: '1p165e4d-30jk-3456',
    //   dppOfPartInserted: '2p165e4d-30jk-8901',
    // },
    // {
    //   key: '11',
    //   date: '2022-11-12',
    //   repairCategory: 'Engine',
    //   errorCode: 'P0130',
    //   errorDescription: 'Oxygen Sensor Circuit Malfunction (Bank 1)',
    //   resolution: 'Replaced oxygen sensor.',
    //   serviceCenterName: 'BCD Car Care',
    //   engineDppUpdated: 'Yes',
    //   dppOfPartExtracted: '3p165e4d-30jk-6789',
    //   dppOfPartInserted: '4p165e4d-30jk-4321',
    // },
    // {
    //   key: '12',
    //   date: '2023-03-15',
    //   repairCategory: 'Body',
    //   errorCode: 'N/A',
    //   errorDescription: 'Tail light assembly replacement',
    //   resolution: 'Replaced broken tail light assembly.',
    //   serviceCenterName: 'EFG Auto Repair',
    //   engineDppUpdated: 'Yes',
    //   dppOfPartExtracted: '5p165e4d-30jk-8910',
    //   dppOfPartInserted: '6p165e4d-30jk-3456',
    // },
    // {
    //   key: '13',
    //   date: '2023-06-25',
    //   repairCategory: 'Engine',
    //   errorCode: 'P0455',
    //   errorDescription: 'Evaporative Emission Control System Leak Detected',
    //   resolution: 'Replaced gas cap and repaired EVAP hoses.',
    //   serviceCenterName: 'HIJ Emissions Specialists',
    //   engineDppUpdated: 'Yes',
    //   dppOfPartExtracted: '7p165e4d-30jk-7890',
    //   dppOfPartInserted: '8p165e4d-30jk-6789',
    // },
    // {
    //   key: '14',
    //   date: '2023-07-05',
    //   repairCategory: 'Body',
    //   errorCode: 'N/A',
    //   errorDescription: 'Side mirror replacement',
    //   resolution: 'Replaced damaged side mirror.',
    //   serviceCenterName: 'KLM Body Shop',
    //   engineDppUpdated: 'Yes',
    //   dppOfPartExtracted: '9p165e4d-30jk-2345',
    //   dppOfPartInserted: '1p165e4d-30jk-9101',
    // },
    // {
    //   key: '15',
    //   date: '2023-09-10',
    //   repairCategory: 'Body',
    //   errorCode: 'N/A',
    //   errorDescription: 'Paint touch-up on hood',
    //   resolution: 'Performed paint touch-up on hood scratches.',
    //   serviceCenterName: 'NOP Paint & Body',
    //   engineDppUpdated: 'Yes',
    //   dppOfPartExtracted: 'N/A',
    //   dppOfPartInserted: 'N/A',
    // },
    // {
    //   key: '16',
    //   date: '2023-09-30',
    //   repairCategory: 'Engine',
    //   errorCode: 'P0500',
    //   errorDescription: 'Vehicle Speed Sensor Malfunction',
    //   resolution: 'Replaced vehicle speed sensor.',
    //   serviceCenterName: 'QRS Auto Repair',
    //   engineDppUpdated: 'Yes',
    //   dppOfPartExtracted: '4p165e4d-30jk-9101',
    //   dppOfPartInserted: '5p165e4d-30jk-5678',
    // },
  ]

  const columns = [
    {
      title: t('job_Date'),
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: t('inv_RepairCategory'),
      dataIndex: 'repairCategory',
      key: 'repairCategory',
    },
    {
      title: t('job_ErrorCode'),
      dataIndex: 'errorCode',
      key: 'errorCode',
    },
    {
      title: t('inv_IssueDescription'),
      dataIndex: 'errorDescription',
      key: 'errorDescription',
      render: rowData => t(rowData),
    },
    {
      title: t('inv_Resolution'),
      dataIndex: 'resolution',
      key: 'resolution',
      render: rowData => t(rowData),
    },
    {
      title: t('inv_ServiceCenterName'),
      dataIndex: 'serviceCenterName',
      key: 'serviceCenterName',
    },
    {
      title: t('inv_DPPUpdated'),
      dataIndex: 'engineDppUpdated',
      key: 'engineDppUpdated',
    },
    {
      title: t('inv_DPPOfPartExtracted'),
      dataIndex: 'dppOfPartExtracted',
      key: 'dppOfPartExtracted',
    },
    {
      title: t('inv_DPPOfPartInserted'),
      dataIndex: 'dppOfPartInserted',
      key: 'dppOfPartInserted',
    },
  ]
  return (
    <ANTDTable
      dataSource={dataSource}
      columns={columns}
      // pagination={false}
      scroll={{ x: 600 }}
      pagination={{
        pageSize: 5,
        total: length(dataSource) || 0,
      }}
      // loading={loader}
    />
  )
}

export default AutomobileModifications
